import { render, staticRenderFns } from "./Tasks.vue?vue&type=template&id=15ae8354&scoped=true"
import script from "./Tasks.vue?vue&type=script&lang=js"
export * from "./Tasks.vue?vue&type=script&lang=js"
import style0 from "./Tasks.vue?vue&type=style&index=0&id=15ae8354&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ae8354",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15ae8354')) {
      api.createRecord('15ae8354', component.options)
    } else {
      api.reload('15ae8354', component.options)
    }
    module.hot.accept("./Tasks.vue?vue&type=template&id=15ae8354&scoped=true", function () {
      api.rerender('15ae8354', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/tasks/Tasks.vue"
export default component.exports